/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  PublishPackageForm,
  PublishPackageForm$Outbound,
  PublishPackageForm$outboundSchema,
} from "../components/publishpackageform.js";

export type PublishSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type PublishSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type PublishSecurity = {
  option1?: PublishSecurityOption1 | undefined;
  option2?: PublishSecurityOption2 | undefined;
};

export type PublishRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  publishPackageForm: PublishPackageForm;
};

/** @internal */
export type PublishSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const PublishSecurityOption1$outboundSchema: z.ZodMiniType<
  PublishSecurityOption1$Outbound,
  PublishSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function publishSecurityOption1ToJSON(
  publishSecurityOption1: PublishSecurityOption1,
): string {
  return JSON.stringify(
    PublishSecurityOption1$outboundSchema.parse(publishSecurityOption1),
  );
}

/** @internal */
export type PublishSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const PublishSecurityOption2$outboundSchema: z.ZodMiniType<
  PublishSecurityOption2$Outbound,
  PublishSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function publishSecurityOption2ToJSON(
  publishSecurityOption2: PublishSecurityOption2,
): string {
  return JSON.stringify(
    PublishSecurityOption2$outboundSchema.parse(publishSecurityOption2),
  );
}

/** @internal */
export type PublishSecurity$Outbound = {
  Option1?: PublishSecurityOption1$Outbound | undefined;
  Option2?: PublishSecurityOption2$Outbound | undefined;
};

/** @internal */
export const PublishSecurity$outboundSchema: z.ZodMiniType<
  PublishSecurity$Outbound,
  PublishSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => PublishSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => PublishSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function publishSecurityToJSON(
  publishSecurity: PublishSecurity,
): string {
  return JSON.stringify(PublishSecurity$outboundSchema.parse(publishSecurity));
}

/** @internal */
export type PublishRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  PublishPackageForm: PublishPackageForm$Outbound;
};

/** @internal */
export const PublishRequest$outboundSchema: z.ZodMiniType<
  PublishRequest$Outbound,
  PublishRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    publishPackageForm: PublishPackageForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      publishPackageForm: "PublishPackageForm",
    });
  }),
);

export function publishRequestToJSON(publishRequest: PublishRequest): string {
  return JSON.stringify(PublishRequest$outboundSchema.parse(publishRequest));
}
